import type { LinePlacementSummary } from "../types";
import {
  HEADLINE_LABEL,
  placementLegendEntries,
  placementSummaryLines,
  placementSwatchSvg,
  placementTooltip,
} from "./mdcpMap";

/** „Rodzaj linii" under a route map: the headline (kablowa / napowietrzna / mieszana), one
 *  swatch per (kind, status) pair drawn on the map, and metres per kind. Shared by the
 *  surveyor's order map, our MDCP panel and the contractor project map, so all three read
 *  the same words the order description carries. `null` summary = the route version has no
 *  typed layers — say so instead of guessing. */
export function LinePlacementLegend({
  summary,
  className = "",
}: {
  summary: LinePlacementSummary | null | undefined;
  className?: string;
}) {
  if (!summary) {
    return (
      <p className={`text-[11px] text-[var(--color-text-muted)] ${className}`}>
        Rodzaj linii: brak danych — wersja trasy nie ma warstw typowanych (kablowa/napowietrzna).
      </p>
    );
  }
  const lines = placementSummaryLines(summary);
  const entries = placementLegendEntries(summary);
  return (
    <div className={`space-y-1 text-[11px] ${className}`} data-testid="line-placement-legend">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="font-semibold text-[var(--color-text)]">
          Rodzaj linii: {HEADLINE_LABEL[summary.headline]}
        </span>
        {entries.map((e) => (
          <span
            key={`${e.status}/${e.placement}`}
            className="inline-flex items-center gap-1 text-[var(--color-text-secondary)]"
            title={placementTooltip(e.placement, e.status)}
          >
            <span
              aria-hidden
              className="inline-flex"
              dangerouslySetInnerHTML={{ __html: placementSwatchSvg(e.placement, e.status) }}
            />
            {placementTooltip(e.placement, e.status)}
          </span>
        ))}
      </div>
      <div className="text-[var(--color-text-muted)]">{lines.join(" · ")}</div>
    </div>
  );
}
